import { render, staticRenderFns } from "./UsersSingleDetails.vue?vue&type=template&id=34fdeea7&"
import script from "./UsersSingleDetails.vue?vue&type=script&lang=js&"
export * from "./UsersSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports